<template>
  <div class="home">
    <!-- 背景 -->
    <HelloWorld />
    <!-- 登录表单 -->
    <div class="login" @keyup.enter="login">
      <!-- register -->
      <div class="title">{{ stringData }}</div>
      <div class="username">
        <input
          type="text"
          v-model="username"
          ref="usernameInput"
          :placeholder="$t('User.account')"
        />
      </div>
      <div class="password">
        <input
          type="password"
          v-model="password"
          :placeholder="$t('User.pwd')"
        />
      </div>
      <div class="ip" v-if="false">
        <input type="text" v-model="hostname" class="ips" />
        <input type="text" v-model="port" class="localhost" />
      </div>
      <div class="select">
        <el-select @change="changeValue" v-model="value">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select_radio">
        <!-- <el-select @change="changeLarge" v-model="large">
          <el-option
            v-for="item in screenLarge"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->

        <el-radio v-model="large" label="2">{{
          this.$t("panel.actual")
        }}</el-radio>
        <el-radio v-model="large" label="1">{{
          this.$t("panel.classic")
        }}</el-radio>
      </div>
      <div class="btn">
        <div class="login_btn" @click="login">{{ $t("newadd.login") }}</div>
      </div>
      <div class="formember">
        <el-checkbox v-model="checkeds">{{ $t("newadd.rember") }}</el-checkbox>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import ElementLocale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import { Base64 } from "js-base64";
import HelloWorld from "@/components/vue-particles.vue";
import { f } from "as-time-line";
// const proxy = require('./proxy')//这个地方引入proxy
export default {
  name: "HomeView",
  components: {
    HelloWorld,
  },
  data() {
    return {
      large: "2",
      hostname: "",
      HTTP: "",
      port: "",
      password: "", //gm5oCAylAoabMWYo
      username: "", //admin
      checkeds: false,
      options: [
        {
          value: "cn",
          label: "简体中文(Simplified)",
        },
        {
          value: "en",
          label: "English",
        },
      ],
      value: "简体中文(Simplified)",
      screenLarge: [
        {
          value: "2",
          label: this.$t("panel.actual"),
        },
        {
          value: "1",
          label: this.$t("panel.classic"),
        },
      ],
      stringData: "",
      address: "/panel",
      HTTP: "http://",
    };
  },
  created() {
    let urlNew = new URL(window.location.href);
    if (urlNew.href.indexOf("?") != -1) {
      let href = urlNew.href.split("?");

      let address1 = href[0].split("/");
      let parameter = href[1].split("=");
      let urlSplicing = address1[2].split(":");
      this.hostname = urlSplicing[0]; //"192.168.0.123"; //
      this.port = urlSplicing[1];
      let name = parameter[1].split("&");
      let word = parameter[2].split("&");
      this.username = name[0];
      this.password = word[0];
      this.address = parameter[3];
      this.login();

      if (urlNew.protocol == "http:") {
        let url = location.host.split(":");
        this.HTTP = "http://";
        this.port = url[1] ? url[1] : "80";
      } else {
        this.HTTP = "https://";
        this.port = url[1] ? url[1] : "443";
      }
    } else {
      let url = location.host.split(":");
      if (urlNew.protocol == "http:") {
        this.HTTP = "http://";
        this.port = url[1] ? url[1] : "80";
      } else {
        this.HTTP = "https://";
        this.port = url[1] ? url[1] : "443";
      }
      this.hostname = url[0];
    }

    // let hostname = "125.122.22.189"; //192.168.0.44 192.168.0.188  192.168.0.123 192.168.0.134
    // let port = 81; //81 8080
    // this.hostname = hostname;
    // this.port = port;

    // let hostname = "192.168.0.123"; //192.168.0.44 192.168.0.188  192.168.0.123 192.168.0.134
    // let port = 23333; //81 8080
    // this.hostname = hostname;
    // this.port = port;
 
    // let hostname = "192.168.0.134"; //192.168.0.44 192.168.0.188  192.168.0.123 192.168.0.134
    // let port = 81; //81 8080
    // this.hostname = hostname;
    // this.port = port;

    //  let hostname = "192.168.0.99"; //192.168.0.44 192.168.0.188  192.168.0.123 192.168.0.134
    // let port = 8080; //81 8080
    // this.hostname = hostname;
    // this.port = port;
    // scsp.scjg.sx.gov.cn:7070/#/
    // ${this.HTTP}120.55.59.57:8080/

    // let hostname ="222.222.99.133"; //192.168.0.44 192.168.0.188  192.168.0.123 192.168.0.134
    // let port = 3333; //81 8080
    // this.hostname = hostname;
    // this.port = port;

    // https://live.lumingtec.cn/#/

    // let hostname ="dxsnvr.com"; //192.168.0.44 192.168.0.188  192.168.0.123 192.168.0.134
    // let port = 82; //81 8080
    // this.hostname = hostname;
    // this.port = port;

    window.sessionStorage.setItem("hostname", this.hostname);
    window.sessionStorage.setItem("HTTP", this.HTTP);
    window.sessionStorage.setItem("port", this.port);
    // const VueI18n = import("vue-i18n").default;
    // const messages = import("@/public/custom/en").default;
    // // 创建VueI18n实例
    // const i18n = new VueI18n({
    //   locale: "en", // 设置默认语言
    //   messages, // 设置语言环境信息
    // });
    // // 将i18n实例挂载到Vue
    // this.$i18n = i18n;
    // this.$i18n.locale = "en";
  },
  mounted() {
    this.stringData = window.configuration.ProjectName
      ? window.configuration.ProjectName
      : "SVMSPro"; //读取window对象赋值
    // const currentLanguage = navigator.language;
    // console.log(currentLanguage); // 输出当前操作系统的语言
    // if (currentLanguage == "zh-CN") {
    //   this.$i18n.locale = "cn";
    //   window.localStorage.setItem("langSet", "cn");
    //   this.value = "简体中文(Simplified)";
    // } else {
    //   this.$i18n.locale = "en";
    //   window.localStorage.setItem("langSet", "  ");
    //   this.value = "English";
    // }
    this.$refs.usernameInput.focus();
    const decodedCookie = decodeURIComponent(document.cookie);
    // if (decodedCookie) {
    //   const cookieArray = decodedCookie.split(";");
    //   for (let i = 0; i < cookieArray.length; i++) {
    //     let key = cookieArray[i].split("=")[0];
    //     let val = cookieArray[i].split("=")[1];
    //     4, 6;
    //     if (key == "password") {
    //       this.password = val;
    //     } else if (key == "username") {
    //       this.username = val;
    //     }
    //     this.setCookie(key, val, 30);
    //   }
    // }
    let lang = window.localStorage.getItem("langSet");
    if (!lang || lang == "cn") {
      this.value = "简体中文(Simplified)";
    } else {
      this.value = "English";
    }
    this.$nextTick(() => {
      this.checkeds = window.localStorage.getItem("checkeds");
      if (this.checkeds == "true") {
        this.checkeds = true;
        this.username = window.localStorage.getItem("username1", this.username);
        this.password = window.localStorage.getItem("password1", this.password);
        this.large = window.localStorage.getItem("screenType")
          ? window.localStorage.getItem("screenType")
          : "2";
      } else {
        this.username = "";
        this.password = "";
        this.checkeds = false;
        this.large = window.localStorage.getItem("screenType")
          ? window.localStorage.getItem("screenType")
          : "2";
      }
    });
  },
  methods: {
    changeLarge(val) {
      sessionStorage.setItem("screenType", val);
    },
    changeValue(val) {
      if (val == "cn") {
        ElementLocale.use(zhLocale);
        this.value = "简体中文(Simplified)";
      } else {
        ElementLocale.use(enLocale);
        this.value = "English";
      }
      window.localStorage.setItem("langSet", val);

      this.$i18n.locale = val;
      this.$forceUpdate();
    },
    //
    async login() {
      // let urlNew = new URL(window.location.href);
      // console.log(urlNew);
      // console.log(this.HTTP, this.hostname, this.port);
      // return;
      let lang = window.localStorage.getItem("langSet");
      if (!lang) {
        ElementLocale.use(zhLocale);
        window.localStorage.setItem("langSet", "cn");
        this.$i18n.locale = "cn";
      }
      if (lang == "cn") {
        ElementLocale.use(zhLocale);
      } else {
        ElementLocale.use(enLocale);
      }
      try {
        let url = `${this.HTTP}${this.hostname}:${this.port}/LoginToService`;
        let { data } = await this.$axios({
          url: url,
          methods: "post",
          params: {
            username: this.username,
            password: Base64.encode(this.password), //  this.password//
          },
        });
        if (data.result == 0) {
          window.sessionStorage.setItem("navigation", "nav");
          window.sessionStorage.setItem("hostname", this.hostname);

          window.sessionStorage.setItem("HTTP", this.HTTP);

          window.sessionStorage.setItem("username", this.username);
          window.sessionStorage.setItem("port", this.port);
          window.sessionStorage.setItem("token", data.token);
          window.sessionStorage.setItem("password", this.password);
          window.sessionStorage.setItem("screenType", this.large);
          window.localStorage.setItem("checkeds", this.checkeds);

          window.localStorage.setItem("username1", this.username);
          window.localStorage.setItem("password1", this.password);
          if (this.checkeds) {
            (document.cookie = `password = ${this.password}`),
              (document.cookie = `username = ${this.username}`);
          }
          this.$store.commit("initIndex", 0);

          if (this.large == 1) {
            this.address = "/panel";
          } else {
            this.address = "/screen";
          }
        
          setTimeout(() => {
            this.$router.push({
              path: this.address,
              params: {
                token: data.token,
              },
            });
          }, 500);
        } else if (data.errorcount > 4) {
          this.$message({
            showClose: true,
            message: `${this.$t("addition.locked")}`,
            type: "error",
            duration: 800,
          });
        } else {
          this.$message({
            showClose: true,
            message: `${this.$t("play.inspect")}`,
            type: "error",
            duration: 800,
          });
        }
      } catch (error) {
        console.log(error);
        this.$message({
          showClose: true,
          message: `${this.$t("play.network")}`,
          type: "error",
          duration: 1000,
        });
      }
    },
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value}; ${expires}; path=/`;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./HomeView.scss";
</style>
